// validate signup form on keyup and submit
$("#nav-login-form").validate({
    rules: {
        username: "required",
        password: "required",
        /*
        username: {
            required: true,
            minlength: 2
        },
        password: {
            required: true,
            minlength: 5
        },
        confirm_password: {
            required: true,
            minlength: 5,
            equalTo: "#password"
        },
        email: {
            required: true,
            email: true
        },
        topic: {
            required: "#newsletter:checked",
            minlength: 2
        },
        agree: "required" */
    },
    messages: {
        /*
        email: "Please enter your firstname",
        password: "Please enter your lastname",
        username: {
            required: "Please enter a username",
            minlength: "Your username must consist of at least 2 characters"
        },
        password: {
            required: "Please provide a password",
            minlength: "Your password must be at least 5 characters long"
        },
        confirm_password: {
            required: "Please provide a password",
            minlength: "Your password must be at least 5 characters long",
            equalTo: "Please enter the same password as above"
        },
        email: "Please enter a valid email address",
        agree: "Please accept our policy",
        topic: "Please select at least 2 topics" */
    }
});



$("#bestell-form").validate({
    rules: {
        name: "required",
        prename: "required",
        lastname: "required",
        street: "required",
        plz: "required",
        agb: "required"


        /*
         username: {
         required: true,
         minlength: 2
         },
         password: {
         required: true,
         minlength: 5
         },
         confirm_password: {
         required: true,
         minlength: 5,
         equalTo: "#password"
         },
         email: {
         required: true,
         email: true
         },
         topic: {
         required: "#newsletter:checked",
         minlength: 2
         },
         agree: "required" */
    },
    messages: {
        /*
         email: "Please enter your firstname",
         password: "Please enter your lastname",
         username: {
         required: "Please enter a username",
         minlength: "Your username must consist of at least 2 characters"
         },
         password: {
         required: "Please provide a password",
         minlength: "Your password must be at least 5 characters long"
         },
         confirm_password: {
         required: "Please provide a password",
         minlength: "Your password must be at least 5 characters long",
         equalTo: "Please enter the same password as above"
         },
         email: "Please enter a valid email address",
         agree: "Please accept our policy",
         topic: "Please select at least 2 topics" */
    }
});